/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as configurationActions from '../actions/ConfigurationActions';

const initialState = {
    page: 0,
    cleanForm: null,
    busqueda: null,
    orden: null,

    showSuccessMsg: false,
    showWarningMsg: false,
    showErrorMsg: false,
    showInfoMsg: false,
    typeMessage: null,
    textMessage: null,
    textTitle: null,
}
const configurationReducerFuntion = (state = initialState, action) => {
    switch (action.type) {
        case configurationActions.SHOW_SUCCESS_MSG:
            return {
                ...state,
                showSuccessMsg: action.showSuccessMsg,
                typeMessage: 'success',
                textMessage: action.textMessage,
                textTitle: action.textTitle,
            };
        case configurationActions.SHOW_WARNING_MSG:
            return {
                ...state,
                showWarningMsg: action.showWarningMsg,
                typeMessage: 'warning',
                textMessage: action.textMessage,
                textTitle: action.textTitle,
            };
        case configurationActions.SHOW_ERROR_MSG:
            return {
                ...state,
                showErrorMsg: action.showErrorMsg,
                typeMessage: 'error',
                textMessage: action.textMessage,
                textTitle: action.textTitle,
            };

        case configurationActions.SHOW_INFO_MSG:
            return {
                ...state,
                showInfoMsg: action.showInfoMsg,
                typeMessage: 'info',
                textMessage: action.textMessage,
                textTitle: action.textTitle,
            };

        case configurationActions.CLEAN_FORM:
            return { ...state, cleanForm: action.cleanForm };

        default:
            return state;
    }
};

export default configurationReducerFuntion;